import React, { useState } from 'react'
import { FileUpload } from 'primereact/fileupload'
import { connect } from 'react-redux'

import { Loading } from '../../components'
import './UploadFileBtn.css'
import { showMessageBox } from '../../store/actions/system.actions'

function UploadFileBtn({
  name,
  url,
  label,
  onUploadCompleted,
  dispatch,
  disabled = false,
  accept = 'image/*, .pdf',
}) {
  // name: form-data field name
  // url: where to send file

  // Hooks
  const [isUploading, setIsUploading] = useState(false)

  // Events
  const onUpload = event => {
    const { xhr } = event
    if (xhr && xhr.status) {
      if (xhr.status === 200) {
        const file_name = xhr.response
        onUploadCompleted(file_name)
      } else {
        dispatch(showMessageBox(null, `Erro durante o Upload. ${xhr.status} - ${xhr.statusText}`))
      }
    }
    setIsUploading(false)
  }
  const onBeforeSend = () => {
    setIsUploading(true)
  }
  const onError = event => {
    const { xhr } = event
    if (xhr && xhr.status) {
      dispatch(showMessageBox(null, `Erro durante o Upload. ${xhr.status} - ${xhr.statusText}`))
    }
    setIsUploading(false)
  }
  // Render
  return (
    <div className="UploadFileBtn">
      <div
        className="UploadFileBtn__container"
        style={{ visibility: isUploading ? 'visible' : 'hidden', textAlign: 'center' }}
      >
        <Loading size="xs" />
      </div>
      <div
        className="UploadFileBtn__container"
        style={{ visibility: isUploading ? 'hidden' : 'visible' }}
      >
        <FileUpload
          disabled={disabled}
          name={name}
          url={url}
          mode="basic"
          chooseLabel={label}
          onUpload={onUpload}
          onBeforeSend={onBeforeSend}
          onError={onError}
          accept={accept}
        ></FileUpload>
      </div>
    </div>
  )
}

export default connect()(UploadFileBtn)
